module.exports = "https://cdn-challenge.mathletics.com/app/277/assets/fonts/9bd029da4737382f43eec132079fddce.woff2";